import { APP_LOGIN_URL } from "../lib/config";

export function ArticleInlineCta() {
  return (
    <p>
      For a large Gmail cleanup, the fastest practical option is <a href={APP_LOGIN_URL}>Emails Unsubscriber</a>: it puts recurring senders in one list, automatically completes supported one-click unsubscribes when you bulk-select them, and opens any remaining confirmation pages together for you to finish.
    </p>
  );
}
